import { optDebugLog } from '../../../util/debug';

export function hasAdobePanel(): boolean {
  return window.__adobe_cep__ != null;
}

interface CepVersion {
  major: string;
  minor: string;
  micro: string;
}

export const getCepApiVersion = (): CepVersion | undefined => {
  return window.__adobe_cep__ && JSON.parse(window.__adobe_cep__.getCurrentApiVersion());
};

export const getCepApiMajorVersion = (() => {
  let cached = -1;
  return (): number => {
    if (cached >= 0) {
      return cached;
    }
    const version = getCepApiVersion();
    if (!version) {
      return cached;
    }
    cached = parseInt(version.major);
    return cached;
  };
})();

export const isInTopFrame = (): boolean => window.top === window;

type WindowWithDebugDirectRouting = Window & {
  debug_directRouting?: boolean;
};

// Dynamic per-call check: isInTopFrame() can change after an AD login redirect
export const routeViaParentFrame = (): boolean => {
  if ((window as WindowWithDebugDirectRouting).debug_directRouting === true) {
    return false;
  }
  const cepVersion = getCepApiMajorVersion();
  const topFrame = isInTopFrame();
  const parentRouting = cepVersion >= 11 && !topFrame;
  optDebugLog('routeViaParentFrame', { cepVersion, topFrame, parentRouting });
  return parentRouting;
};

export enum AdobeApps {
  Premiere = 'PPRO',
  AfterEffects = 'AEFT',
  Photoshop = 'PHSP',
  PhotoshopExt = 'PHXS',
  Audition = 'AUDT',
}

export const getAppId = (): string | undefined => {
  const hostEnv = window.__adobe_cep__ && JSON.parse(window.__adobe_cep__.getHostEnvironment());
  return hostEnv?.appId;
};

export const isPremiere  = () => getAppId() === AdobeApps.Premiere;
export const isAe        = () => getAppId() === AdobeApps.AfterEffects;
export const isPs        = () => { const id = getAppId(); return id === AdobeApps.Photoshop || id === AdobeApps.PhotoshopExt; };
export const isAudition  = () => getAppId() === AdobeApps.Audition;

export const getAppVersion = (): string | undefined => {
  const hostEnv = window.__adobe_cep__ && JSON.parse(window.__adobe_cep__.getHostEnvironment());
  return hostEnv?.appVersion;
};
